import React from 'react'
import { withRouter } from 'react-router-dom'

import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { Toast } from 'primereact/toast';
import { InputMask } from 'primereact/inputmask';
import { Button } from 'primereact/button';

import NavBar from '../../componentes/Navbar'

import EstadoService from '../../app/service/EstadoService'
import CidadeService from '../../app/service/CidadeService'
import UsuarioService from '../../app/service/UsuarioService'
import PerfilService from '../../app/service/PerfilService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './usuarios.css'

class CadastroUsuario extends React.Component {

  constructor(props) {
    super(props);

    this.estadoService = new EstadoService();
    this.cidadeService = new CidadeService();
    this.usuarioService = new UsuarioService();
    this.perfilService = new PerfilService();
    this.onEstadoChange = this.onEstadoChange.bind(this);
    this.onCidadeChange = this.onCidadeChange.bind(this);
    this.onPerfilChange = this.onPerfilChange.bind(this);

    this.state = {
      //Cadastro de Usuário
      nome: '',
      email: '',
      cpf: '',
      endereco: '',
      numero: '',
      cep: '',
      bairro: '',
      complemento: '',
      telefone1: '',
      telefone2: '',
      estados: [],
      cidades: [],
      perfil: null,
      selectEstado: null,
      selectCidade: null,
      perfis: []
    };
  }

  listarEstados = async () => {
    await this.estadoService.listarEstados()
      .then(response => {
        this.setState({estados: response.data});
      })
  }

  limparCampos = () => {
    this.setState({
      nome: '',
      email: '',
      cpf: '',
      endereco: '',
      numero: '',
      cep: '',
      bairro: '',
      complemento: '',
      telefone1: '',
      telefone2: '',
      perfil: null,
      selectEstado: null,
      cidade: null,
      selectCidade: null,
      empresa: null
    })
  }

  cadastrarUsuario = () => {
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Usuários', detail: 'Informe o nome do Usuário', life: 4000});
      return false;
    }

    if(this.state.email == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Usuários', detail: 'Informe o E-Mail do Usuário', life: 4000});
      return false;
    }

    if(this.state.selectCidade == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Usuários', detail: 'Informe a Cidade', life: 4000});
      return false;
    }

    if(this.state.perfil == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Usuários', detail: 'Informe o Perfil do Usuário', life: 4000});
      return false;
    }

    const usuarioLogado = this.context.usuarioAutenticado;

    this.usuarioService.cadastrarUsuario({
      nome: this.state.nome,
      email: this.state.email,
      cpf: this.state.cpf,
      endereco: this.state.endereco,
      numero: this.state.numero,
      cep: this.state.cep,
      bairro: this.state.bairro,
      complemento: this.state.complemento,
      telefone1: this.state.telefone1,
      telefone2: this.state.telefone2,
      perfil: this.state.perfil,
      cidade: this.state.selectCidade,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Cadastro de Usuários', detail: 'Usuário cadastrado com sucesso', life: 4000});
      this.props.history.push('/usuarios')
    }).catch(error => {
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Grupo de Trabalho', detail:`${this.state.detail}`, life: 4000});
    })
  }

  voltar = () => {
    this.props.history.push('/usuarios')
  }

  async onEstadoChange(e) {
    await this.setState({ selectEstado: e.value });
    this.listarCidades();
  }

  onCidadeChange(e) {
    this.setState({selectCidade: e.value})
  }

  onPerfilChange(e) {
    this.setState({perfil: e.value});
    console.log('Perfil selecionado', e.value)
  }

  listarCidades = async () => {
    if(this.state.selectEstado) {
      await this.cidadeService.listarCidades(this.state.selectEstado.codigo)
        .then(response => {
          this.setState({cidades: response.data})
        }).catch(error => {
          this.setState(error.response.data)
          this.toast.show({severity:'error', summary: 'Usuários', detail:`${this.state.detail}`, life: 4000});
        })
    }
  }

  listarPerfis = async () => {
    await this.perfilService.listarPerfis()
      .then(response => {
        this.setState({perfis: response.data})
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Perfis', detail:'Erro ao listar perfis', life: 4000});
      })
  }

  componentDidMount() {
    this.listarEstados();
    this.listarPerfis();
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-users"></i>
                    <span> Cadastro de Usuários</span>
                  </h3>  
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Nome<span className="obrigatorioAsterisco"> *</span></label>
                        <InputText id="nome" 
                                   type="text" 
                                   style={{width: '100%'}} 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label>E-Mail<span className="obrigatorioAsterisco"> *</span></label>
                        <InputText id="email" 
                                   type="text" 
                                   style={{width: '100%'}} autoComplete="off" 
                                   value={this.state.email}
                                   onChange={e => this.setState({email: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                        
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label>CPF</label>
                        <InputMask mask="999.999.999-99" 
                                   id="cpf" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.cpf}
                                   onChange={e => this.setState({cpf: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Endereço</label>
                        <InputText id="endereco" 
                                   type="text" 
                                   style={{width: '100%'}} 
                                   autocomplete="off"
                                   value={this.state.endereco}
                                   onChange={e => this.setState({endereco: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Bairro</label>
                        <InputText id="bairro" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.bairro}
                                   onChange={e => this.setState({bairro: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-1">
                      <div className="form-group">
                        <label>Número</label>
                        <InputText id="numero" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.numero}
                                   onChange={e => this.setState({numero: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label>Cep</label>
                        <InputMask mask="99999-999" 
                                   id="cep" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.cep}
                                   onChange={e => this.setState({cep: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Complemento</label>
                        <InputText id="complemento" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.complemento}
                                   onChange={e => this.setState({complemento: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
    
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Estado<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.selectEstado} 
                            options={this.state.estados} style={{width: '100%'}}
                            optionLabel="estado" 
                            filter showClear filterBy="estado"
                            onChange={this.onEstadoChange}
                            id="estado"
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Cidade<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.selectCidade} options={this.state.cidades} style={{width: '100%'}}
                            optionLabel="nome" emptyMessage="Nenhuma cidade para este estado"
                            filter showClear filterBy="nome"
                            onChange={this.onCidadeChange}
                            id="cidade"
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Telefone 1</label>
                        <InputMask mask="(99)9 9999-9999" 
                                   id="telefone1" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.telefone1}
                                   onChange={e => this.setState({telefone1: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Telefone 2</label>
                        <InputMask mask="(99)9999-9999" 
                                   id="telefone2" 
                                   type="text" 
                                   style={{width: '100%'}}
                                   value={this.state.telefone2}
                                   onChange={e => this.setState({telefone2: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Perfil<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.perfil} options={this.state.perfis} style={{width: '100%'}}
                            optionLabel="nome"
                            id="perfil"
                            onChange={this.onPerfilChange}
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{paddingLeft: '20px'}}>
                          <Button label="Cadastrar" 
                                  className="p-button-primary p-button-text"
                                  onClick={this.cadastrarUsuario}/>
                        
                          &nbsp;
                <Button label="Limpar" 
                        className="p-button-warning p-button-text"
                        onClick={this.limparCampos}/>
              
                &nbsp;
                <Button label="Voltar" 
                        className="p-button-secondary p-button-text"
                        onClick={this.voltar}/>
                </div>
              </div>
             </section>
            </div>
          </div>
      </>
    );
  }
}
CadastroUsuario.contextType = AuthContext;
export default withRouter (CadastroUsuario);